import * as React from "react";
import Navigation from "../components/navigation";
import Footer from "../components/footer";

export default function ImpressumPage() {
  return (
    <>
      <Navigation/>
      <div>
        <div className="content--simple-text"></div>
        <div className="content--simple-text"></div>
        <div className="content--simple-text"><p>Impressum</p>
          <p>Angaben gemäß § 5 TMG:</p>
          <p>Physiolymp-Saar
            Physiotherapeut
            Tim Martin</p>
          <p>Postanschrift:</p>
          <p>Rischbachstraße 17
            66386 St Ingbert</p>
          <p>Kontakt:</p>
          <p>Telefon: 06894 5820122
            E-Mail: timarnemartin@gmx.de</p>
          <p>Vertreten durch:</p>
          <p>Tim Martin</p>
          <p>Hinweise zur Website</p>
          <p>Information gemäß § 36 VSBG
            Gemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in
            Verbrauchersachen) erklärt der Betreiber dieser Website:</p>
          <p>Wir sind weder bereit noch verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.</p>
          <p>Das Impressum wurde mit dem Impressums-Generator der activeMind AG erstellt</p></div>
      </div>
      <Footer/>
    </>
  );
}
